import { isEmpty, map } from 'lodash';
import React, { FC, useContext, MouseEvent } from 'react';
import { NavMenuItem, NavMenuLang, NavMenuVariant } from '../SideNav';
import { NavContext } from '../SideNav/NavContext';
import { NavMenuElement } from '../SideNav/NavElement';
import { NavLanguage } from '../SideNav/NavLanguage';

interface NavigationButtonsProps {
  contactUs?: NavMenuItem;
  menuList?: NavMenuItem[];
  languageInfo?: NavMenuLang;
  onSelect?: (navId: string, e: MouseEvent) => void;
  onLanguageToggle?: (e: MouseEvent) => void;
}
export const NavigationButtons: FC<NavigationButtonsProps> = ({
  contactUs,
  languageInfo,
  menuList,
  onSelect = () => true,
  onLanguageToggle
}) => {
  const context = useContext(NavContext);
  return (
    <ul className={`sub-menu-mobile  ${context.showContact ? 'show-contact' : ''}`} role="menubar">
      {map(menuList, element => (
        <li className="nav-elements position-relative" role="none" key={`nav-elements-${element.navId}`}>
          <NavMenuElement
            navId={element.navId}
            ariaLabel={element.ariaLabel}
            label={element.label}
            invertedLogo={element.invertedLogo}
            logo={element.logo}
            className={`nav-drop-element ${NavMenuVariant.HORIZONTAL}`}
            onClick={e => onSelect('', e)}
            isMobile={true}
            href={element.href}
          />
        </li>
      ))}
      {languageInfo && languageInfo.isVisible && (
        <li className="nav-elements position-relative " role="none">
          <NavMenuElement
            navId={languageInfo.navId}
            onClick={onLanguageToggle}
            className={`nav-drop-element ${NavMenuVariant.HORIZONTAL}`}
            label={languageInfo.label}
            href={languageInfo.href}
            isMobile={true}
          />
        </li>
      )}
    </ul>
  );
};

export const NavigationButtonsDesktop: FC<NavigationButtonsProps> = ({
  contactUs,
  menuList,
  languageInfo,
  onSelect = () => true,
  onLanguageToggle
}) => {
  return (
    <div className="d-flex flex-row justify-content-between side-spacer">
      <ul className="d-flex flex-row justify-content-start" role="none">
        {menuList.length > 0 &&
          map(menuList, element => (
            <li className="nav-elements position-relative" role="none" key={`nav-elements-${element.navId}`}>
              <NavMenuElement
                navId={element.navId}
                ariaLabel={`${element.ariaLabel}`}
                label={element.label}
                invertedLogo={element.invertedLogo}
                logo={element.logo}
                className={`nav-drop-element ${NavMenuVariant.HORIZONTAL}`}
                onClick={e => onSelect(element.navId, e)}
                isMobile={true}
                href={element.href}
              />
            </li>
          ))}
      </ul>
      <ul className="d-flex flex-row justify-content-end" role="none">
        {languageInfo && languageInfo.isVisible && (
          <li className="nav-elements position-relative " role="none">
            <NavLanguage
              navId={languageInfo.navId}
              className={`nav-drop-element ${NavMenuVariant.HORIZONTAL}`}
              label={languageInfo.label}
              href={languageInfo.href}
              hrefLang={languageInfo.hrefLang}
              onLanguageToggle={onLanguageToggle}
            />
          </li>
        )}
      </ul>
    </div>
  );
};
